import reactStringReplace from 'react-string-replace';
import { twMerge } from 'tailwind-merge';

export interface HighlightProps extends React.HTMLAttributes<HTMLSpanElement> {
  match?: string | RegExp;
  children?: React.ReactNode;
  className?: string;
}

export const Highlight: React.FC<HighlightProps> = ({
  match,
  children,
  className,
  ...restProps
}) => {
  if (
    typeof children === 'string' ||
    (Array.isArray(children) && children.every((node) => typeof node === 'string') && match)
  ) {
    return (
      <>
        {reactStringReplace(children as string | string[], match, (match, index) => (
          <span
            key={index}
            className={twMerge('bg-tint-light font-medium', className)}
            {...restProps}
          >
            {match}
          </span>
        ))}
      </>
    );
  }

  return children;
};

Highlight.displayName = 'Highlight';
